import { Form } from './';
import { formPropTypes } from './common';

import React from 'react';

const TeamForm = ({ formProps, values, meta, onInputChange }) => (
  <Form {...formProps}>
    <Form.Input
      name="name"
      value={values.name}
      onChange={onInputChange}
      label="Name"
      placeholder="Name"
      required
      fluid
    />
    <Form.Input
      name="abbreviation"
      value={values.abbreviation}
      onChange={onInputChange}
      label="Abbreviation"
      placeholder="Abbreviation"
      fluid
    />
  </Form>
);

TeamForm.propTypes = formPropTypes;

export default TeamForm;



// WEBPACK FOOTER //
// ./src/components/TeamForm.js